export const spectacleLensFlow = {
  steps: [
    { id: "age", type: "number", question: "Enter your age", stepLabel: "1/06" },
    {
 
      id: "lensDesign", type: "single", stepLabel: "2/06",
      question: "Choose your current lens design",
      staticOptions: [
        { id: 2, name: "Single Vision", sub: "One focal distance", illustration: "single" },
        { id: 1, name: "Bifocal", sub: "Distance and near zones", illustration: "bifocal" },
        { id: 3, name: "Progressive", sub: "Seamless, all distances", illustration: "progressive" },
        { id: 4, name: "None", sub: "I don't wear lenses yet", illustration: "none" },
      ],
    },
    {
      id: "challenges", type: "multi", stepLabel: "3/06",
      question: "Do you experience any of the following challenges?",
      options: [
        { name: "Tired Eyes" }, { name: "Blurred Near Vision" },
        { name: "Near Vision Discomfort" }, { name: "None" },
      ],
    },
    {
      id: "deviceUsed", type: "single", variant: "text", stepLabel: "4/06",
      question: "Which of the following you use the most?",
      staticOptions: [{ id: 1, name: "Laptop" }, { id: 2, name: "Mobile Phone" }, { id: 3, name: "Computer/Desktop" }],
    },
    {
      id: "drivingFrequency", type: "single", variant: "text", stepLabel: "5/06",
      question: "How often do you drive?",
      staticOptions: [{ id: 1, name: "Never" }, { id: 2, name: "Monthly" }, { id: 3, name: "Weekly" }, { id: 4, name: "Daily" }],
    },
    {
      id: "timeOutside", type: "single", variant: "text", stepLabel: "6/06",
      question: "How often do you spend time outside?",
      staticOptions: [{ id: 1, name: "Occasionally" }, { id: 2, name: "Regularly" }, { id: 3, name: "Daily" }],
    },
  ],
  onComplete: "navigateCollection",
};

export const deriveLensRecommendations = (answers) => {
  const recs = new Set();
  if (answers.deviceUsed?.name === "Mobile Phone") recs.add("Progressive Lens");
  if (["Regularly", "Daily"].includes(answers.timeOutside?.name)) recs.add("Photochromatic Lens");
  return Array.from(recs);
};